import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/solid';
import { useTour } from '@reactour/tour';
import { useLocation, useNavigate } from 'react-router-dom';

interface TutorialButtonProps {}

export const TutorialButton: React.FC<TutorialButtonProps> = () => {
  const { setIsOpen } = useTour();
  const location = useLocation();
  const navigate = useNavigate();
  const handleClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
    }
    setIsOpen(true);
  };
  return (
    <button
      onClick={handleClick}
      className="flex items-center rounded-md p-2 text-neutralText transition-colors duration-200 hover:text-primary dark:text-neutralText-dark dark:hover:text-primary"
      id="tutorial-button"
      data-tooltip-content="Relancer le tutoriel"
      data-tooltip-id="tooltip"
      data-tooltip-place="bottom"
      data-tooltip-delay-show={100}
      data-tooltip-offset={5}
    >
      <BookOpenIcon className="h-5 w-5" />
    </button>
  );
};
